import fromAnyToString from './fromAnyToString';

const fromAnyToInteger = (string) => Number.parseInt(fromAnyToString(string), 10);

export default fromAnyToInteger;
